const safeModelName = (modelName, fallback) => {
  const source = String(modelName || fallback || 'report').replace(/\.ifc$/i, '');
  return source.replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 60) || 'report';
};

const compactUtcTimestamp = (date) => {
  const iso = date.toISOString();
  return `${iso.slice(0, 10).replace(/-/g, '')}_${iso.slice(11, 16).replace(':', '')}`;
};

export const complianceReportDownloadName = (modelName, fallback, generatedAt = new Date()) => (
  `AHA_Compliance_Report_${safeModelName(modelName, fallback)}_${compactUtcTimestamp(generatedAt)}.pdf`
);

export const presentedAIJobFilename = (job) => {
  const stored = job?.filename || `aha-${job?.id || 'report'}.pdf`;
  if (job?.kind === 'remediation_report' && stored.startsWith('AHA_remediation_')) {
    return stored.replace('AHA_remediation_', 'AHA_Compliance_Report_');
  }
  return stored;
};